import { render, staticRenderFns } from "./ItemFilterMemberCollectionLayout.vue?vue&type=template&id=12840587&scoped=true&"
import script from "./ItemFilterMemberCollectionLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterMemberCollectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12840587",
  null
  
)

export default component.exports